import MyClientsLiquidityApplicationsPanel from "./MyClientsLiquidityApplicationsPanel";

export default MyClientsLiquidityApplicationsPanel;
